import {AiOutlineLinkedin} from 'react-icons/ai'
import { AiOutlineTwitter } from 'react-icons/ai'
import { AiFillGithub } from 'react-icons/ai'
import {AiOutlineMail} from 'react-icons/ai'

const data=[
    {id:1 , link:'https://www.linkedin.com/in/shikha-gupta-12a2b5199/', icon:<AiOutlineLinkedin/>},
    {id:2 , link:'https://twitter.com/ShikhaG61708689', icon:<AiOutlineTwitter/>},
    {id:3 , link:'https://github.com/shikhu51197', icon:<AiFillGithub/>},
    {id:4 , link:'https://mail.google.com/mail/u/0/#inbox?compose=CllgCKHRLhvzxXGTlCQDGMKDpkXhmXqKjPpcxrkchgfdQPNDsTVJtRJjBhcXsPfmJXsXRFgxzdV', icon:<AiOutlineMail/>},

]

export default data